/**
 * Stable node ids for every row the tree renders.
 *
 * Each builder mirrors the ids the original monolith used, so expanded state
 * and selection targets keep working exactly as before.
 */
export const plantNodeId = (plantId) => `plant-${plantId}`;

export const wbsNodeId = (wbsId) => `wbs-${wbsId}`;

export const inputDataNodeId = (projectId, revision) =>
  `input-${projectId}-${revision}`;

export const estimationNodeId = (projectId, revision) =>
  `estimation-${projectId}-${revision}`;

export const specNodeId = (projectId) => `spec-${projectId}`;

export const pvDashboardNodeId = (projectId, revision) =>
  `pvdash-${projectId}-${revision}`;

export const revisionDocNodeId =(projectId, revision, docId) =>
  `revdoc-${projectId}-${revision}-${docId}`;

export const procurementNodeId = (plantId, categoryKey) =>
  `proc-${plantId}-${categoryKey}`;

// A section heading under a plant - Estimation, Procurement, Dashboard, …
// The "-section" ending is load-bearing: these ids start with "plant-" like
// the plant's own, and handleNodeToggle tells them apart by that suffix
// before firing a plant's fetches.
export const sectionNodeId = (plantId, sectionKey) =>
  `${plantNodeId(plantId)}-${sectionKey}-section`;

// One row of a listed section under a plant - Project Control, Dashboard,
// AIMS, Client Data. The section key is part of the id so two sections can
// carry a row of the same name without colliding.
export const sectionItemNodeId = (plantId, sectionKey, itemKey) =>
  `sect-${plantId}-${sectionKey}-${itemKey}`;

export const procurementItemNodeId = (plantId, categoryKey, itemId) =>
  `procitem-${plantId}-${categoryKey}-${itemId}`;

export const drawingsFolderNodeId = (wbsId) => `drawings-${wbsId}`;

export const drawingNodeId = (wbsId, drawingId) =>
  `drawing-${wbsId}-${drawingId}`;

// The "3D Modeling" branch under a Design Automation WBS. Deliberately not
// prefixed "plant-"/"wbs-": handleNodeToggle keys the WBS and document
// fetches off those prefixes, and these folders load nothing of their own -
// the drawings ride on the WBS record (see drawingsOf).
export const modelingNodeId = (wbsId) => `modeling-${wbsId}`;

// The "2D Drawing" placeholder leaf inside "3D Modeling" - shown as a row,
// nothing behind it exists yet.
export const modelingTwoDDrawingNodeId = (wbsId) => `modeling-2d-${wbsId}`;

// The "BOM" folder inside "3D Modeling"; its drawing leaves reuse
// drawingNodeId above.
export const bomFolderNodeId = (wbsId) => `bom-${wbsId}`;
